module.exports = __webpack_public_path__ + "static/media/EBGaramond-Regular.43f11c29.eot";